import { NotifyErrorWrapper, NotifySuccess } from '@/helpers/core/notifications'
import { createNBPTThreshold, deleteNBPTThreshold, getNBPTThresholds } from '@/services/eos/alerts/nbpt-alerts.service'
import type { INBPTThresholdFilters } from '@/types/eos/filters'
import type { INBPTForm } from '@/types/eos/forms'
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'

export const useNBPTThresholds = () => {
  const queryClient = useQueryClient()

  const getNBPTThresholdsQuery = (filters: INBPTThresholdFilters) =>
    useQuery({
      queryKey: ['nbpt-thresholds', filters],
      queryFn: () => getNBPTThresholds(filters),
    })

  const createNBPTThresholdMutation = useMutation({
    mutationFn: (form: INBPTForm) => createNBPTThreshold(form),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['nbpt-thresholds'] })
      NotifySuccess('Threshold created')
    },
    onError: NotifyErrorWrapper('Failed to create threshold'),
  })

  const deleteNBPTThresholdMutation = useMutation({
    mutationFn: (id: number) => deleteNBPTThreshold(id),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['nbpt-thresholds'] })
      NotifySuccess('Threshold deleted')
    },
    onError: NotifyErrorWrapper('Failed to delete threshold'),
  })

  return {
    getNBPTThresholdsQuery,
    createNBPTThresholdMutation,
    deleteNBPTThresholdMutation,
  }
}
